import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { withViewport } from '../../util/uiHelpers';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './InsuranceAndFinancePage.module.css';
import HeroSection from './Sections/HeroSection';
import VisitSupplierSection from './Sections/VisitSupplierSection';
import FeatureSection from './Sections/FeatureSection';

export const InsuranceAndFinancePageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      title={intl.formatMessage({ id: 'InsuranceAndFinancePage.title' })}
      description={intl.formatMessage({ id: 'InsuranceAndFinancePage.description' })}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <HeroSection />
          <FeatureSection />
          <VisitSupplierSection />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

InsuranceAndFinancePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const InsuranceAndFinancePage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(InsuranceAndFinancePageComponent);

export default InsuranceAndFinancePage;
